module.exports = __webpack_public_path__ + "static/media/noimage.3b0eb7f1.png";